import React from 'react';

import './paginator__down-button-icon.scss';

const PaginatorDownButtonIcon = () => {
    return <div className="paginator__down-button-icon" />;
};

export default PaginatorDownButtonIcon;
